import 'reflect-metadata'
import { IAuthService, ILogger, LoggerConfig } from '@velociti/core'
import { VelocitiLogger, ConsoleAppender } from '@velociti/common'
import { AuthService } from 'src/system/auth/lib/services/auth'
import AxiosRemoteContentService from 'src/system/content/services/AxiosRemoteContentService'
import { ExperienceService } from 'src/system/content/services/ExperienceService'
import IExperienceService from 'src/system/content/services/IExperienceService'
import ILocalContentService from 'src/system/content/services/ILocalContentService'
import ILogService from 'src/system/content/services/ILogService'
import IPackService from 'src/system/content/services/IPackService'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'
import IReportingService from 'src/system/content/services/IReportingService'
import IResourceService from 'src/system/content/services/IResourceService'
import ISignatureService from 'src/system/content/services/ISignatureService'
import IUserService from 'src/system/content/services/IUserService'
import { LogService } from 'src/system/content/services/LogService'
import { PackService } from 'src/system/content/services/PackService'
import { ReportingService } from 'src/system/content/services/ReportingService'
import { ResourceService } from 'src/system/content/services/ResourceService'
import RxDBLocalContentService from 'src/system/content/services/RxDBLocalContentService'
import { SignatureService } from 'src/system/content/services/SignatureService'
import { UserService } from 'src/system/content/services/UserService'
import IQuoteService from 'src/system/content/services/IQuoteService'
import { QuoteService } from 'src/system/content/services/QuoteService'
import IDashboardService from 'src/system/content/services/IDashboardService'
import { DashboardService } from 'src/system/content/services/DashboardService'

let logger: ILogger
let localContentService: ILocalContentService
let remoteContentService: IRemoteContentService
let authService: IAuthService
let resourceService: IResourceService
let packService: IPackService
let userService: IUserService
let signatureService: ISignatureService
let logService: ILogService
let experienceService: IExperienceService
let reportingService: IReportingService
let quoteService: IQuoteService
let dashboardService: IDashboardService

export default async ({ app }) => {
  logger = new VelocitiLogger(new LoggerConfig([new ConsoleAppender()]))
  localContentService = new RxDBLocalContentService()
  remoteContentService = new AxiosRemoteContentService(app.config.globalProperties.$axios)
  authService = new AuthService(app.config.globalProperties.$axios, logger)
  resourceService = new ResourceService(localContentService, remoteContentService)
  packService = new PackService(localContentService, remoteContentService)
  userService = new UserService(localContentService, remoteContentService)
  signatureService = new SignatureService(localContentService, remoteContentService)
  logService = new LogService(remoteContentService)
  experienceService = new ExperienceService(localContentService, remoteContentService)
  reportingService = new ReportingService(remoteContentService)
  quoteService = new QuoteService(localContentService, remoteContentService)
  dashboardService = new DashboardService(remoteContentService)

  await localContentService.init()

  app.provide('logger', logger)
  app.provide('localContentService', localContentService)
  app.provide('remoteContentService', remoteContentService)
  app.provide('authService', authService)
  app.provide('resourceService', resourceService)
  app.provide('packService', packService)
  app.provide('userService', userService)
  app.provide('signatureService', signatureService)
  app.provide('logService', logService)
  app.provide('experienceService', experienceService)
  app.provide('reportingService', reportingService)
  app.provide('quoteService', quoteService)
  app.provide('dashboardService', dashboardService)
}

export {
  logger,
  localContentService,
  remoteContentService,
  authService,
  resourceService,
  packService,
  userService,
  signatureService,
  logService,
  experienceService,
  quoteService,
  dashboardService,
}
